
import { EditButton } from "./buttons/EditButton";
import { CopyLinkButton } from "./buttons/CopyLinkButton";
import { ShareWhatsAppButton } from "./buttons/ShareWhatsAppButton";
import { SaveButton } from "./buttons/SaveButton";
import { DeleteButton } from "./buttons/DeleteButton";
import { Eye } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface QuotationActionsProps {
  quotation: any;
  onEdit: (quotation: any) => void;
  onDelete?: (quotation: any) => void;
  onView?: (quotation: any) => void;
  onShare?: (quotation: any) => void;
}

export function QuotationActions({ 
  quotation, 
  onEdit, 
  onDelete,
  onView,
  onShare
}: QuotationActionsProps) {
  const navigate = useNavigate();

  const handleView = () => {
    if (onView) {
      onView(quotation);
    } else {
      // Direct navigation as fallback if no onView handler provided
      navigate(`/quotation/${quotation.code}`);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <Button
        variant="ghost"
        size="icon"
        className="h-8 w-8 text-[#0073B7] hover:text-[#004080] hover:bg-blue-50"
        onClick={handleView}
      >
        <Eye className="h-4 w-4" />
      </Button>
      <EditButton onClick={() => onEdit(quotation)} />
      {onView && <CopyLinkButton quotation={quotation} />}
      {onShare && <ShareWhatsAppButton quotation={quotation} />}
      <SaveButton quotation={quotation} />
      {onDelete && <DeleteButton quotation={quotation} onDelete={() => onDelete(quotation)} />}
    </div>
  );
}
